module.exports = __webpack_public_path__ + "img/records.0958dec0.png";